import template from './currency.html';
import controller from './currency.controller';
import './currency.scss';

let currencyComponent = {
  restrict: 'E',
  bindings: {
    acl: '=',
    hasACL: '='
  },
  template,
  controller
};

export default currencyComponent;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/currency/currency.component.js